import { Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { DataService } from 'src/app/services/data.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { DatePipe, formatDate } from '@angular/common';

@Component({
  selector: 'app-training-results',
  templateUrl: './training-results.component.html',
  styleUrl: './training-results.component.scss'
})
export class TrainingResultsComponent {

  courseId: string = '';
  header = this.translate('Training Results');
  links: link[] = [
    {
      name: 'رجوع',
      icon: 'pi pi-angle-right',
      link: ``,
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Training'), link: `/training/training-page/`},
    { name: this.translate('Training Results'), link: `/training/training-results/` },

  ];
  queryParams: any = {};
  stats: stat[] = [];
  messages: any[] = [];
  graphData: any[] = [];
  activeTRTabIndex: number = 0;
  tabIndex: number = 0;
  currentQBankId: string = "";
  chartData: any;
  barChartOptions = {
    plugins: {
      legend: {
        labels: {
          font: {
            size: 14,
            family: 'SSTArabic'
          }
        },
        display: false
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
          color :'white',
          autoSkip: false, // Keeps all labels
          maxTicksLimit: 10, // Limits number of visible labels
          maxRotation: 90,
        }
      },
      y: {
        ticks: {
          font: {
            size: 12,
            family: 'SSTArabic'
          },
            color :'white',
          stepSize: 1
        }
      }
    }
  };
  noGraphs: string[] = ['DRAG_DROP', 'MULTI_POINT_SCALE', 'MULTI_SELECT_SCALE'];
  page: number = 1;
  size: number = 10;

  trainingDetails:any;
  ratingDetails:any;
  surveys:any[] = [];
  assessments:any[] = [];
  users:any[] = [];

  trainingDetailsData:any[] = [
    {
      'key': 'number_of_users',
      'arabic': this.translate('number_of_users'),
      'icon':'icon-svg icon-svg-85',
      'value': '0',
    },
    {
      'key': 'number_of_trainers',
      'arabic': this.translate('number_of_trainers'),
      'icon':'icon-svg icon-svg-3',
      'value': '0',
    },
    {
      'key': 'completed_attendees',
      'arabic': this.translate('completed_attendees'),
      'icon':'icon-svg icon-svg-46',
      'value': '0',
    }
]
trainingDetailsSession:any[] = [  
    {
      'key': 'Online',
      'arabic': this.translate('Session Online'),
      'icon':'icon-svg icon-svg-15',
      'value': '0',
    },
    {
      'key': 'Onsite',
      'arabic': this.translate('Session Onsite'),
      'icon':'icon-svg icon-svg-16',
      'value': '0',
    },
    {
      'key': 'Survey',
      'arabic': this.translate('Session Survey'),
      'icon':'icon-svg icon-svg-8',
      'value': '0',
    },
    {
      'key': 'Assessment',
      'arabic': this.translate('Session Assessment'),
      'icon':'icon-svg icon-svg-130',
      'value': '0',
    },
  ]

  CurrTab: string = 'Users'
  from:string = '';
  back:string = '';

  skelition: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router
  ) { }

  ngOnInit() {
    let prevPage: number = this.page;
    let prevSize: number = this.size;

    this.route.queryParams.subscribe(params => {
      if (params['page'] && params['page'] !== prevPage) {
        prevPage = params['page'];
        this.page = Number(params['page']);        
        this.fetchData();
      }

      if (params['size'] && params['size'] !== prevSize) {
        prevSize = params['size'];
        this.size = Number(params['size']);
        this.fetchData();
      }
      if (params['from']) {
        this.from = params['from'];
      }

      if (params['back']) {
        this.back = params['back'];
      }

      if (params['activeTRTabIndex']) {
        const activeTRTabIndex = +params['activeTRTabIndex'];
        if (!isNaN(activeTRTabIndex)) {
          this.activeTRTabIndex = activeTRTabIndex;
        }
      }
    })

    this.route.params.subscribe(params => {
      this.courseId = params['courseId'];
      if (this.courseId) {
        this.fetchData();
      }
      let queryParams = {
        'back': this.back, 
      };
      this.breadcrumbs[0] = { name: this.translate('Training'), link: this.back};
      this.breadcrumbs[1] = { name: this.translate('Training Results'), link: `/training/training-results/` + this.courseId, queryParams: queryParams };
      this.links[0].link = this.back;
    });
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }
    
  async fetchData() {
    this.skelition = true;
    try {
      let res = await this.dataService.postData(`course/getCourseResults/`,{ courseId: this.courseId });
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.skelition = false;
      this.trainingDetails = res.data['CourseResults'][0]['Training Details'];
      this.ratingDetails = res.data['CourseResults'][0]['Rating'];
      this.surveys = res.data['Surveys'];
      if (this.surveys.length > 0)
      {
        this.surveys.forEach(survey => {
          survey.graphData.forEach((data: any) => {
            if (data.type == 'bar') {
              data.graphData = this.getBarGraph(data.data, data.questionType,survey.totalUsers);
            } else if (data.type == 'smile') {
              data.graphData = this.getSmileData(data.data,survey.totalUsers);
            } else if (data.type == 'rate') {
              data.graphData = this.getStartData(data.data);
            } else if (data.questionType == "MULTI_SELECT_SCALE") {
              console.log(data);
              try {
                data.type = 'table'
              } catch (error) {
                console.log(error)
              }
            } else if (data.questionType == "CALENDAR") {
              try {
                data.type = 'calander'
              } catch (error) {
                console.log(error)
              }
            }
          });
        });
      }
      this.assessments = res.data['Assessments'];
      this.users = res.data['Users'];
      this.trainingDetailsData.map((item, index) => {
        item.value = this.trainingDetails[item.key]
      });
      this.trainingDetailsSession.map((item, index) => {
        item.value = (this.trainingDetails.session_count[item.key]) ? this.trainingDetails.session_count[item.key] : 0
      });
      this.trainingDetailsData = [...this.trainingDetailsData,...this.trainingDetailsSession];

    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e },
      ]
    }
  }

  multiselectGraph(data: any): ChartDataset[] | null {
    if (!Array.isArray(data)) {
      data = [data]
    }

    const chartData: { labels: string[], values: number[] }[] = data.map((question: Question) => {
        if (!question.meta || !Array.isArray(question.meta)) {
            console.error('Error: Invalid data structure.');
            return null;
        }

        return question.meta.map((item: MetaItem) => {
            const columns: string[] = item.columns.map((column: string) => column);
            const values: number[] = item.fields.map((field: any) => field.value.length);
            return {
                labels: columns,
                values: values
            };
        });
    }).flat().filter(Boolean) as { labels: string[], values: number[] }[];

    // Creating chart datasets
    const datasets = chartData.map(item => {
        return {
            labels: item.labels,
            data: item.values,
            backgroundColor: 'rgba(54, 162, 235, 0.5)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1
        };
    });
    return datasets;
  }

  getName(name: any) {
    return Object.values(name).join(' ');
  }

  openUrl(type:string , id:string, ratingFor:string = '', ratingForID:string = ''){

    let queryParams: any = {}
    if (ratingFor != '' && ratingForID != '')
    {
      queryParams['courseId'] = this.courseId;
      queryParams['ratingFor'] = ratingFor;
      queryParams['ratingForID'] = ratingForID;
    }

    queryParams['_id'] = this.courseId;
    queryParams['from'] = this.from;
    queryParams['source'] = 'training';
    queryParams['activeTRTabIndex'] = this.activeTRTabIndex;

    this.router.navigate([`/${type}/results/${id}`],{ queryParams })
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");
    const formattedDate = `${hours}:${minutes} ${day}-${month}-${year} `;
    return formattedDate;
  }

  getBarGraph(graphdata: any, name: string, totalUserResults:number): any {
    let dataPercentage = graphdata.datasets.data.map((value: number) => ((value / totalUserResults) * 100).toFixed(2));
    return {
      labels: this.labelmaker(graphdata.label),
      datasets: [
        {
          backgroundColor: graphdata.datasets.backgroundColor.map((item: any) => item ? '#FACB7D' : '#F7517F'),
          label: graphdata.datasets.label,
          data: dataPercentage
        }
      ]
    };
  }

  labelmaker(inputArray: string[]): string[][] {
    const result: string[][] = [];
    inputArray.forEach(item => {
      if (item.length <= 30) {
        result.push([item]);
      } else {
        result.push(["..." + item.substring(0, 30)]);
      }
    });
    return result;
  }

  getSmileData(data: any, totalUserResults:number) {
    const labels = data.label;
    const images = data.label_images;
    const datasets = data.datasets.data;
    if (labels.length === images.length && images.length === datasets.length) {
      return labels.map((label: string, index: number) => {
        return { label, image: images[index], count: ((datasets[index] / totalUserResults) * 100).toFixed(2) };
      });
    }
  }

  getStartData(data: any) {
    const labels = data.label;
    const datasets = data.datasets.data;
    if (labels.length === datasets.length) {
      return labels.map((label: string, index: number) => {
        return { label, value: datasets[index] };
      });
    }
  }

  onPageChange(event: any) {
    console.log(event);
    this.page = event.first ? (event.first + 1) : 1;
    this.size = event.rows ?? 10;
    const params = { page: this.page, size: this.size };
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }

  onTabChange(event: any) {
    this.activeTRTabIndex = event.index;
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { activeTRTabIndex: this.activeTRTabIndex },
      queryParamsHandling: 'merge'
    });
  }

  ChangeTab(tab:any,event: any)
  {
    this.CurrTab = tab;
  }
}



interface MetaItem {
  columns: string[];
  fields: { value: any[] }[];
}

interface Question {
  meta: MetaItem[];
}

interface ChartDataset {
  labels: string[];
  data: number[];
  backgroundColor: string;
  borderColor: string;
  borderWidth: number;
}
